import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowUpRight, Inbox } from "lucide-react";

import setAuthToken from "../../../utils/setAuthToken";
import { formatDateWidget } from "../../../utils/dateUtils";

import { Spinner, ArticleStatusBadge, ArticleTypeLabel } from "../../../design-system";

class LatestArticles extends Component {
  constructor(props) {
    super(props);
    this.state = { articles: [], loading: true };
  }

  componentDidMount() {
    this.loadArticles();
  }

  loadArticles = async () => {
    try {
      const token = localStorage.getItem("jwtToken");
      if (token) setAuthToken(token);
      const response = await axios.get("/api/articles?limit=5");
      if (response.data.success) {
        this.setState({ articles: response.data.articles || [], loading: false });
      }
    } catch (error) {
      console.error("Error loading articles:", error);
      this.setState({ loading: false });
    }
  };

  render() {
    const { articles, loading } = this.state;

    return (
      <div className="flex flex-col h-full">
        <header className="flex items-center justify-between px-4 py-3 border-b border-border">
          <h3 className="text-sm font-bold tracking-tight">Derniers articles</h3>
          <Link to="/dashboard/articles" className="text-xs font-medium text-mute hover:text-text inline-flex items-center gap-1">
            Voir tout <ArrowUpRight className="w-3 h-3" strokeWidth={1.8} />
          </Link>
        </header>
        <div className="flex-1">
          {loading ? (
            <div className="flex items-center justify-center py-8 text-mute"><Spinner size="sm" /></div>
          ) : articles.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-8 text-center text-mute text-sm">
              <Inbox className="w-5 h-5 mb-2 text-mute-2" strokeWidth={1.6} />
              Aucun article
            </div>
          ) : (
            <ul className="divide-y divide-border">
              {articles.map((article) => (
                <li key={article.id} className="px-4 py-3">
                  <div className="flex items-start justify-between gap-2 mb-1">
                    <Link
                      to={`/dashboard/articles/${article.id}`}
                      className="text-sm font-semibold text-text hover:underline underline-offset-2 leading-tight line-clamp-2"
                    >
                      {article.title}
                    </Link>
                    <ArticleStatusBadge status={article.status} size="sm" />
                  </div>
                  {article.excerpt && (
                    <div className="text-[11.5px] text-mute mt-0.5 font-serif italic line-clamp-1">
                      — {article.excerpt}
                    </div>
                  )}
                  <div className="flex items-center gap-2 text-[11.5px] text-mute mt-1">
                    <ArticleTypeLabel type={article.type} />
                    <span className="text-mute-2">·</span>
                    <span className="font-mono">{formatDateWidget(article.publishedAt || article.createdAt)}</span>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    );
  }
}

export default LatestArticles;
